import React from "react";
import { fileUrl } from "../lib/api";

export function Logo({ size = "md", logoPath = null, companyName = null, showText = false }) {
  const heights = { sm: "h-8", md: "h-12", lg: "h-16", xl: "h-24" };
  const src = logoPath ? fileUrl(logoPath) : "/rightpay-logo.png";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <div className="bg-white rounded-xl px-3 py-2 flex items-center justify-center shadow-lg shadow-blue-900/20">
        <img src={src} alt={companyName || "RightPay"} className={`${heights[size]} w-auto object-contain`} />
      </div>
      {showText && companyName && (
        <span className="font-extrabold text-xl tracking-tight text-slate-100">{companyName}</span>
      )}
    </div>
  );
}
